import { createFileRoute } from '@tanstack/react-router'
import StoragePage from '@/components/pages/StoragePage/StoragePage'

export const Route = createFileRoute('/$workspaceName/$environment/storage')({
  component: StorageRoute,
})

function StorageRoute() {
  return <StoragePage />
}
